import {createSelector} from '@store/@common';

import LibraryStore from 'stores/library/LibraryStore';

const baseState = createSelector(LibraryStore as any);

export const libraryFormState = createSelector([baseState], s => s.get('formState'));

export const librarySearchCalls = createSelector([baseState], s => s.get('searchCalls'));

export const librarySearchInfo = createSelector([baseState], s => s.get('searchInfo'));

export const librarySearchType = createSelector([baseState], s => s.get('searchType'));

export const libraryTagToDelete = createSelector([baseState], s => s.get('libraryTagToDelete'));

export const librarySources = createSelector([baseState], s => s.get('sources'));

// Example of nested selector
export const libraries = createSelector([librarySources], s => s.get('libraries'));

export const libraryShareAccessible = createSelector([baseState], s => s.get('shareAccessible'));

export const libraryId = createSelector([baseState], s => {
  const libraryIdString = s.getIn(['formState', 'library']);
  // TODO weirdly, these come from the python backend as strings.
  return libraryIdString && libraryIdString !== 'any' ? parseInt(libraryIdString, 10) : null;
});
